import { fetchApi } from '../api/digitalVault';
import { parsePlaylistDefinition } from '../utils';
// this api retrieves a playlist's metadata
const getPlaylistByUri = async (uri, logger) => {
    const response = await fetchApi({ uri }, `playlist/metadata`, {}, true, logger);
    return parsePlaylistDefinition(response.playlistDefinition);
};
export default getPlaylistByUri;
